import { Component, ViewEncapsulation, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

import { TranslationService } from '../../../../shared/services/translation.service';

@Component({
	selector: 'copo-snackbar-save-ecall-off',
	templateUrl: './snackbar-save-ecall-off.component.html',
	styleUrl: './snackbar-save-ecall-off.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [TranslateModule]
})
export class SnackbarSaveEcallOffComponent implements OnInit {
	eCallOffSubmissionMessage = '';

	constructor(
		private readonly snackBarRef: MatSnackBarRef<SnackbarSaveEcallOffComponent>,
		@Inject(MAT_SNACK_BAR_DATA) public data: string,
		private readonly translationService: TranslationService
	) {}

	ngOnInit() {
		this.eCallOffSubmissionMessage = this.translationService.getTR('ecall-off.submitted.successfully');
		this.eCallOffSubmissionMessage = this.eCallOffSubmissionMessage
			.replace('{{value}}', this.data);
	}

	dismiss() {
		this.snackBarRef.dismiss();
	}
}
